import TypographyContainer from "../../../Components/UiKits/Typography";

export default function Typography() {
    return (
        <div className='page-body'>
            <TypographyContainer />
        </div>
    )
}
